import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { Row, Col} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { console_log,parseQueryString, getSubdomain,getUid } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import { showMessage } from '../../actions/FlashMessageActions';
import Loader from './../loader/loader';
import { messages } from '../../constants/messages';
import { sendData } from '../../analytics/sendData'



class LoginWithPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            errorMessage: '',
            domain: window.location.host,
            msisdnNotFound: false,
            reason: '',
            username: '',
            password: '',
            submitted: false,
            loading: false,
            error: {
                username:false,
                password:false
            },
            regURL: `/register`
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentWillMount(){
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    isValid(){
        let { username, password,error} = this.state;
        if(!(username)){
            error.username=true;
           this.setState({
               error:error
           })
        }else{
            error.username=false;
           this.setState({
               error:error
           })
        }
        if(!(password)){
            error.password=true;
           this.setState({
               error:error
           })
        }else{
            error.password=false;
            this.setState({
                error:error
            })
        }
        if(error.username || error.password){
            return false
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(username).toLowerCase())){
            this.props.showMessage({
                message: messages[config.lang].emailFormate,
                type: false
            });
            return false
        }
        return true
    }
    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password, returnUrl } = this.state;
        let uidData= JSON.parse(sessionStorage.getItem('uid'));
        if(this.isValid()) {
            this.callAuthenticate({
                username: username,
                password: password,
                uid : getUid() || uidData.uid 
            });
        }
    }
    callAuthenticate(input) {
        this.setState({
            loading:true
        })
            axios.post(vars.BASE_API_URL + `/twoStepLogin`,{ 
            email: input.username,
            password: input.password,
            uid: input.uid
            })
            .then((response) => {
                this.setState({
                    loading:false
                })
                if (response.data.success) {
                    let data = {
                        success: response.data.success,
                        uid: input.uid,
                        token: response.data.data.token,
                        subscriptionInfo: response.data.data.payload
                    };
                    axios.defaults.headers.common['authorization'] = response.data.data.token;
                    sessionStorage.setItem("authorized", JSON.stringify(data))
                    sendData('', '', '', 'Accessed', { method: 'username', rid: data.subscriptionInfo.rockmanId, status: 'success', url: window.location.href});
                    this.props.checkAccess(data);
                    this.props.history.push('/category/vod/?uid=' + data.uid);
                }
                else {
                    this.props.showMessage({
                        message: response.data.data.msg,
                        type: false
                    });
                    // alert(response.data.data.msg);
                    //this.props.history.push("/restricted");
                }
            })
            .catch((error) => {
                this.setState({
                    loading:false
                })
                console.log(error);
                // this.props.history.push("/restricted");
            })
    }

    render() {
            let usernameLabel = 'Email';
            let passwordLabel = 'Password';
            if(config.domain == 'pt') {
                 usernameLabel = 'Email';
                 passwordLabel = 'Senha';
            }
            const { username, password, loading, error } = this.state;
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                            <form name="form" onSubmit={this.handleSubmit}>
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="areYou"
                                        defaultMessage="Are you already a member of Mobio360?"
                                    />
                                </h1>
                                <p>
                                    <FormattedMessage id="passwordThenConfirm"
                                        defaultMessage="Please sign in with your Email Address"
                                    />
                                </p>

                                <div className="login-page-mobile_num">
                                    <input type="text" name="username" placeholder={usernameLabel} value={username} onChange={this.handleChange} className="LoginRoute-number" />
                                    {error.username && <span className="error-message">
                                        <FormattedMessage id="email-required"
                                            defaultMessage="Email is required."
                                        />
                                    </span>}
                                    <input type="password" name="password" placeholder={passwordLabel} value={password} onChange={this.handleChange} className="LoginRoute-number" />
                                    {error.password && <span className="error-message">
                                        <FormattedMessage id="password-required"
                                            defaultMessage="Password is required."
                                            />
                                        </span>}
                                    <button type="submit"  disabled={loading} className="LoginRoute-button">
                                    {loading ?<Loader/> :
                                         <FormattedMessage id="passwordLoginButton"
                                         defaultMessage="Login"
                                     />
                                     }
                                       
                                    </button>
                                </div>
                            </Row>
                            </form>
                        </Col>
                                <Row className="login-page-content ">

                                    <Link className="reg-link" to={`/forgot-password/?uid=${getUid()}`}>
                                        <FormattedMessage id="forgot-password-link"
                                            defaultMessage="Forgot Password"
                                        />
                                    </Link>
                                     <br/>
                                    <Link className="reg-link" to={`/register/?uid=${getUid()}`}>
                                        <FormattedMessage id="passwordSignupOnLogin"
                                            defaultMessage="Register"
                                        />
                                    </Link>
                                </Row>
                        <Col>

                        </Col>
                    </Row>
                </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide,
        showMessage,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithPassword);



// WEBPACK FOOTER //
// ./src/components/Login/LoginWithPassword.js